import { IconName } from '@infotech-soe/erp-ui-kit';
import { ActionProcessMode } from '@infotech-soe/metaschema';

import {
  BuiltinCaptionType,
  Caption,
  CaptionType,
} from '../../../models/caption/Caption';
import CategoryCommandImpl from '../impl/CategoryCommandImpl';

import CategoryCommand, { RefreshStrategy } from './CategoryCommand';
import refreshStrategyBuilder, {
  MoveRefreshStrategyBuilderArgs,
} from './MoveRecordCommand/refreshStrategyBuilder';

class MoveRecordCommand extends CategoryCommand<
  void,
  MoveRefreshStrategyBuilderArgs
> {
  constructor(commandImpl: CategoryCommandImpl<void>) {
    super(commandImpl);

    this.refreshStrategyBuilder = refreshStrategyBuilder;
  }

  public async getCaption(): Promise<Caption> {
    return {
      type: CaptionType.BUILT_IN,
      caption: BuiltinCaptionType.MOVE,
    };
  }

  public getIcon(): IconName {
    return 'move';
  }

  public getRefreshStrategy(): RefreshStrategy {
    return RefreshStrategy.DYNAMIC;
  }

  public getRefreshRules(): undefined {
    return undefined;
  }

  public getProcessMode(): ActionProcessMode {
    return this.commandImpl.getProcessMode();
  }
}

export default MoveRecordCommand;
